<style>
  .disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transition: opacity 0.5s;
  }
</style>

<script>
  import { getContext, onMount } from 'svelte';
  import Form from '../../../../components/inputs/form';
  import TextInput from '../../../../components/inputs/text';
  import SwitchInput from '../../../../components/inputs/switch';
  import RichTextInput from '../../../../components/inputs/richtext';
  import SectionNav from '../../../../components/navigation/section';
  import Preview from '../../../../components/buttons/preview.card';
  import CommunicationType from '../../../../components/inputs/communication.type';
  import DateTimeInput from '../../../../components/inputs/datetime';
  import uuid from 'uuid-browser/v4';

  const client = getContext('apollo');

  export let value;
  export let review = true;
  let program = value;
  export let id;
  export let index = 0;

  function changeEmail(i) {
    index = i;
  }

  const NAMES = {
    Tips: 'Get Ready',
    ThankYou: 'Thank You',
    Reminder: 'Reminder'
  };

  const TIMES = {
    Tips: 'Sent 7 days before the event',
    ThankYou: 'Sent 2 days after the event',
    Reminder: 'Sent 2 days before the event'
  };

  function add(e) {
    e.preventDefault();
    value.communications = [
      ...value.communications,
      { id: uuid(), type: 'Custom' }
    ];
    index = value.communications.length - 1;

    return false;
  }

  function remove(uuid) {
    value.communications = [...value.communications.filter(c => c.id !== uuid)];

    index = index - 1;
  }
</script>

<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-12">
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-9">
        {#each program.communications as communication, i} {#if index === i}
        <Form>
          {#if communication.type === 'Custom'}
          <div class="help">
            {communication.date ? `Sends on ${communication.date}` : ''}
          </div>
          {:else}
          <div class="help">
            {TIMES[communication.type] ? TIMES[communication.type] : ''}
          </div>
          {/if} {#if communication.type !== 'Custom'}
          <div class="form-group">
            <SwitchInput
              label="Use Default Program Communication?"
              name="override"
              bind:value="{communication.useParent}"
            ></SwitchInput>
          </div>
          {/if}
          <div class:disabled="{communication.useParent}">
            <div class="form-group">
              <TextInput
                bind:value="{communication.subject}"
                placeholder="Subject"
                label="Subject"
                disabled="{communication.useParent}"
              ></TextInput>
            </div>
            <!--<div class="form-group">
              <CommunicationType
                disabled="{communication.useParent}"
                bind:value="{communication.type}"
                placeholder="Type"
                label="Type"
              ></CommunicationType>
            </div>-->
            {#if communication.type === 'Custom'}
            <div class="form-group">
              <DateTimeInput
                bind:value="{communication.date}"
                label="Send On Date"
                placeholder="Send On Date"
              ></DateTimeInput>
            </div>
            {/if}
            <div class="form-group">
              <RichTextInput
                disabled="{communication.useParent}"
                bind:value="{communication.body}"
                placeholder="Body"
                label="Body"
              ></RichTextInput>
            </div>
            {#if communication.type === 'Custom'}
            <div class="text-right">
              <div
                on:click="{() => remove(communication.id)}"
                class="button secondary small"
              >
                REMOVE COMMUNICATION
              </div>
            </div>
            {/if}
          </div>
        </Form>
        {/if} {/each}
      </div>
      <div class="cell small-12 medium-3">
        <SectionNav hasSub="{true}">
          <ul>
            {#each program.communications as communication, i}
            <li class:active="{i === index}" on:click="{() => changeEmail(i)}">
              {NAMES[communication.type] ? NAMES[communication.type] :
              communication.type}
            </li>
            {/each}
          </ul>

          <div class="text-center" slot="under">
            {#if !review}
            <a on:click="{add}" href="">Add Communication</a>
            {/if}
          </div>
        </SectionNav>
      </div>
    </div>
  </div>
</div>
